window.setGridHeight = (selector) => {
  this.heightArray = [];
  this.offsetArrayArray = [];
  this.sectionArray = [];

  document.querySelectorAll(selector).forEach((grid, i) => {
    var tmp = {
      index: i,
      offsetheight: grid.closest(`[data-equal]`).offsetTop,
    };
    this.offsetArrayArray.push(tmp);
  });

  this.diffrentsHeights = [];
  this.offsetArrayArray.forEach(function (e) {
    if (this.diffrentsHeights.includes(e.offsetheight) == false) {
      this.diffrentsHeights.push(e.offsetheight);
    }
  });

  this.diffrentsHeights.forEach(function (e) {
    var data = [];
    for (var i = 0; i < this.offsetArrayArray.length; i++) {
      if (this.offsetArrayArray[i].offsetheight == e) {
        data.push(this.offsetArrayArray[i]);
      }
    }

    var getAllHeightArray = [];
    data.forEach(function (ele) {
      document.querySelectorAll(selector)[ele.index].removeAttribute("style");
      getAllHeightArray.push(
        document.querySelectorAll(selector)[ele.index].offsetHeight
      );
    });

    var getMaxHeight = Math.max.apply(Math, getAllHeightArray);
    data.forEach(function (ele) {
      document.querySelectorAll(selector)[ele.index].style.minHeight =
        getMaxHeight + "px";
    });
  });
};

function adjustGridHeight() {
  const selectors = [
    '.productitem--title',
    '.productitem--brand',
    '.product_custom__price',
    '.bundle_variant'
  ];

  const scopes = new Set();

  document.querySelectorAll('li.productgrid--item').forEach(item => {
    const parent = item.parentElement;
    if (parent) scopes.add(parent);
  });

  scopes.forEach(scope => {
    selectors.forEach(selector => {
      const items = scope.querySelectorAll(`li.productgrid--item ${selector}`);
      if (items.length === 0) return;

      items.forEach(el => el.style.minHeight = '');

      const rowMap = new Map();
      items.forEach(el => {
        const offset = el.offsetTop;
        if (!rowMap.has(offset)) rowMap.set(offset, []);
        rowMap.get(offset).push(el);
      });

      rowMap.forEach(group => {
        const maxHeight = Math.max(...group.map(el => el.offsetHeight));
        group.forEach(el => {
          el.style.minHeight = `${maxHeight}px`;
        });
      });
    });
  });
}

adjustGridHeight();
window.addEventListener('load', adjustGridHeight);
window.addEventListener('resize', adjustGridHeight);

adjustGridHeight();

// setTimeout(adjustGridHeight, 5000);

window.addEventListener('load', adjustGridHeight);
window.addEventListener('resize', adjustGridHeight);

document.addEventListener('DOMContentLoaded', function () {
  var elem = document.querySelector(".bundle-collection--section .bundle_product_flickity");
  var flkty;

  function initFlickity() {
    if (elem) {
      imagesLoaded(elem, function () {
        flkty = new Flickity(elem, {
          cellSelector: '.productgrid--item',
          freeScroll: true,
          autoPlay: false,
          cellAlign: 'left',
          contain: true,
          accessibility: true,
          groupCells: true,
          pageDots: false,
          prevNextButtons: true,
          adaptiveHeight: true,
          arrowShape: 'M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z'
        });

        const viewport = elem.querySelector('.flickity-viewport');
        const slider = elem.querySelector('.flickity-slider');
        const sliderWrapper = document.createElement('div');
        sliderWrapper.classList.add('flickity-slider--wrapper');
        viewport.appendChild(sliderWrapper);
        sliderWrapper.appendChild(slider);
      });
    }
  }

  initFlickity();

  window.addEventListener('resize', function () {
    if (flkty) {
      flkty.destroy();
    }
    initFlickity();
  });
});

class DiscreetPackagingUpdater {
  constructor() {
    if (window.discreetPackaging) {
      this.settings = window.discreetPackaging;
      this.discreetPackagingCheckbox = document.getElementById('discreet-packaging-checkbox');
      this.discreetPackagingProductId = this.settings.discreet_packaging_product.id;
      this.enableDiscreetPackaging = this.settings.enable_discreet_packaging;

      this.handleCheckboxChange = this.handleCheckboxChange.bind(this);

      // if (this.enableDiscreetPackaging !== null && this.discreetPackagingCheckbox != null) {
      //   this.discreetPackagingCheckbox.addEventListener('change', this.handleCheckboxChange);
      // } else {
      //   if (this.settings.CartDiscreetPackagingItem) {
      //     this.removeProductFromCart(this.settings.CartDiscreetPackagingItem);
      //   }
      // }
      // this.updateCheckboxState();
    }
  }

  handleCheckboxChange() {
    if (this.discreetPackagingCheckbox.checked) {
      this.addProductToCart(this.discreetPackagingProductId);
    } else {
      this.removeProductFromCart(this.discreetPackagingProductId);
    }
  }

  addProductToCart(productId) {
    const formData = {
      'items': [{
        'id': productId,
        'quantity': 1
      }]
    };

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        console.log('Product added to cart:', data);
        location.reload();
        // this.updateCartSection();
      })
      .catch(error => {
        console.error('Error adding product to cart:', error);
      });
  }

  removeProductFromCart(productId) {
    const updates = {
      [productId]: 0
    };

    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        console.log('Product removed from cart:', data);
        location.reload();
        // this.updateCartSection();
      })
      .catch(error => {
        console.error('Error removing product from cart:', error);
      });
  }

  updateCartSection() {
    const sectionUrl = `${window.location.pathname}`;
    console.log(sectionUrl)
    return fetch(sectionUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSectionElement = doc.querySelector('.discreet-packaging-class');
        if (!newSectionElement) {
          throw new Error(`Section with ID ${this.sectionId} not found in the fetched HTML`);
        }
        const newSectionHtml = newSectionElement.innerHTML;
        const sectionElement = document.querySelector('.discreet-packaging-class');

        if (sectionElement) {
          sectionElement.innerHTML = newSectionHtml;
          // Re-initialize the checkbox state and event listener
          this.discreetPackagingCheckbox = document.getElementById('discreet-packaging-checkbox');
          this.discreetPackagingCheckbox.addEventListener('change', this.handleCheckboxChange);
          this.updateCheckboxState();
        }
      })
      .catch(error => {
        console.error('Error updating cart section:', error);
      });
  }
  updateCheckboxState() {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(cart => {
        const discreetPackagingItem = cart.items.find(item => item.id === this.discreetPackagingProductId);
        this.discreetPackagingCheckbox.checked = !!discreetPackagingItem;
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
      });
  }
}


// Function to retrieve selected product IDs
function getSelectedProductIds() {
  var containers = document.querySelectorAll('.bundle_product_item');
  var totalPriceDisplay = document.querySelector('.current_bundle_price .trans-money');
  var selectedItemCountDisplay = document.querySelector('.total_number');
  var selectedProductIds = [];
  const scriptElement = document.querySelector('[data-section-type="bundle-products"]');
  if (!scriptElement) return;
  const scriptContent = scriptElement.textContent.trim();
  const scriptData = JSON.parse(scriptContent);
  const moneyFormat = scriptData.settings.money_format;
  var totalPrice = 0;
  console.log("moneyFormat", moneyFormat);

  function formatMoney(amount, moneyFormat) {
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    if (typeof amount === 'string') {
      amount = amount.replace('.', '');
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    switch (moneyFormat.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(amount, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(amount, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(amount, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(amount, 0, '.', ',');
        break;
    }

    return moneyFormat.replace(placeholderRegex, value);
  }

  function updateTotalItemCount() {
    var totalItemCount = selectedProductIds.reduce((total, item) => total + (item.quantity || 0), 0);
    if (selectedItemCountDisplay) {
      selectedItemCountDisplay.textContent = totalItemCount;
    }
  }

  function updateTotalPrice(moneyFormat) {
    totalPrice = selectedProductIds.reduce((total, item) => {
      var itemPrice = parseFloat(item.price) || 0;
      return total + (itemPrice * item.quantity);
    }, 0);
    console.log("totalPrice", totalPrice, moneyFormat);
    if (totalPriceDisplay) {
      totalPriceDisplay.textContent = formatMoney(totalPrice, moneyFormat);
    }
  }

  function updateSelectedProduct(checkbox, price, quantity) {
    var productId = checkbox.value;
    var existingProductIndex = selectedProductIds.findIndex(p => p.id === productId);
    if (existingProductIndex !== -1) {
      selectedProductIds[existingProductIndex].price = price;
      selectedProductIds[existingProductIndex].quantity = quantity;
    } else {
      selectedProductIds.push({ id: productId, price: price, quantity: quantity });
    }
  }

  containers.forEach(function (container) {
    var js_bundle_selection = container.querySelector('.js-bundle-selection');
    var bundle_product_id = js_bundle_selection ? js_bundle_selection.getAttribute('data-product-id') : null;
    var variantSelection = bundle_product_id ? document.getElementById('variant-selection-' + bundle_product_id) : null;
    var checkbox = container.querySelector('input[name="bundleproducts"]');
    var dropdownDisplay = container.querySelector('.variant-dropdown-display');
    var titleDisplay = dropdownDisplay ? dropdownDisplay.querySelector('.variant-title') : null;
    var priceDisplay = dropdownDisplay ? dropdownDisplay.querySelector('.variant-price') : null;
    var price = checkbox ? parseFloat(checkbox.getAttribute('data-price')) : 0;
    var quantityInput = container.querySelector('.quantity-input');
    var quantityMinus = container.querySelector('.quantity-minus');
    var quantityPlus = container.querySelector('.quantity-plus');
    var hasVariants = variantSelection && variantSelection.querySelectorAll('li').length > 1;

    if (!titleDisplay && dropdownDisplay) {
      titleDisplay = document.createElement('span');
      titleDisplay.classList.add('variant-title');
      dropdownDisplay.appendChild(titleDisplay);
    }
    if (!priceDisplay && dropdownDisplay) {
      priceDisplay = document.createElement('span');
      priceDisplay.classList.add('variant-price');
      dropdownDisplay.appendChild(priceDisplay);
    }

    if (checkbox) {
      checkbox.checked = true;
      container.classList.add('active');
    }

    function handleVariantSelection(variant, selectedVariantId, selectedVariantPrice, selectedVariantName) {
      var currentQuantity = parseInt(quantityInput.value);
      var currentProductId = checkbox.value;

      checkbox.value = selectedVariantId;
      checkbox.setAttribute('data-price', selectedVariantPrice);
      variantSelection.classList.remove('active');
      js_bundle_selection.classList.toggle('active');

      if (titleDisplay && priceDisplay) {
        titleDisplay.textContent = selectedVariantName;
        priceDisplay.textContent = formatMoney(selectedVariantPrice, moneyFormat);
      }

      // Update selected product with the new variant details
      var existingProductIndex = selectedProductIds.findIndex(p => p.id === currentProductId);
      if (existingProductIndex !== -1) {
        selectedProductIds[existingProductIndex].id = selectedVariantId;
        selectedProductIds[existingProductIndex].price = selectedVariantPrice;
      } else {
        selectedProductIds.push({ id: selectedVariantId, price: selectedVariantPrice, quantity: currentQuantity });
      }

      // Update total price
      updateTotalPrice(moneyFormat);
      updateTotalItemCount();

      variants.forEach(function (v) {
        v.classList.remove('selected');
      });
      variant.classList.add('selected');
    }

    function handleCheckboxChange() {
      var currentQuantity = parseInt(quantityInput.value);
      if (checkbox.checked) {
        container.classList.add('active');
        updateSelectedProduct(checkbox, price, currentQuantity);
      } else {
        container.classList.remove('active');
        var itemIndex = selectedProductIds.findIndex(p => p.id === checkbox.value);
        if (itemIndex !== -1) {
          selectedProductIds.splice(itemIndex, 1);
        }
      }
      updateTotalPrice(moneyFormat);
      updateTotalItemCount();
    }

    if (hasVariants && js_bundle_selection && variantSelection) {
      js_bundle_selection.addEventListener('click', function () {
        document.querySelectorAll('.variant-selection.active').forEach(function (selection) {
          if (selection !== variantSelection) {
            selection.classList.remove('active');
            const correspondingPlusIcon = selection.closest('.bundle_product_item').querySelector('.js-bundle-selection');
            correspondingPlusIcon.classList.remove('active');
          }
        });
        variantSelection.classList.toggle('active');
        js_bundle_selection.classList.toggle('active');
      });

      var variants = variantSelection.querySelectorAll('li');
      var firstVariant = variants[0];
      var firstVariantId = firstVariant.getAttribute('data-variant-id');
      var firstVariantPrice = parseFloat(firstVariant.getAttribute('data-variant-price'));
      var firstVariantName = firstVariant.getAttribute('data-variant-name').trim();

      handleVariantSelection(firstVariant, firstVariantId, firstVariantPrice, firstVariantName);

      variants.forEach(function (variant) {
        variant.addEventListener('click', function () {
          var selectedVariantId = variant.getAttribute('data-variant-id');
          var selectedVariantPrice = parseFloat(variant.getAttribute('data-variant-price'));
          var selectedVariantName = variant.getAttribute('data-variant-name').trim();
          handleVariantSelection(variant, selectedVariantId, selectedVariantPrice, selectedVariantName);
        });
      });
    }

    function updateQuantity(newQuantity) {
      var item = selectedProductIds.find(p => p.id === checkbox.value);
      if (item) {
        item.quantity = newQuantity;
      }
      updateTotalPrice(moneyFormat);
      updateTotalItemCount();
    }

    if (quantityMinus) {
      quantityMinus.addEventListener('click', function () {
        var currentValue = parseInt(quantityInput.value);
        if (currentValue > 1) {
          quantityInput.value = currentValue - 1;
          updateQuantity(currentValue - 1);
        }
      });
    }

    if (quantityPlus) {
      quantityPlus.addEventListener('click', function () {
        var currentValue = parseInt(quantityInput.value);
        quantityInput.value = currentValue + 1;
        updateQuantity(currentValue + 1);
      });
    }

    if (quantityInput) {
      quantityInput.addEventListener('change', function () {
        var currentValue = parseInt(quantityInput.value);
        if (currentValue < 1) {
          quantityInput.value = 1;
          currentValue = 1;
        }
        updateQuantity(currentValue);
      });
    }

    if (checkbox) {
      checkbox.addEventListener('change', function () {
        handleCheckboxChange();
      });
    }

    handleCheckboxChange(); // Initialize checkbox state and update total price/item count
  });

  updateTotalPrice(moneyFormat); // Update total price after initial setup
  updateTotalItemCount(); // Update total item count after initial setup
  return selectedProductIds;
}

function updateSelectedProductIds() {
  var containers = document.querySelectorAll('.bundle_product_item.active');
  var productIds = [];
  containers.forEach(function (container) {
    var checkbox = container.querySelector('input[name="bundleproducts"]');
    var quantityInput = container.querySelector('.quantity-input');
    var productId = checkbox.value;
    var item = { id: productId, quantity: parseInt(quantityInput.value) };
    productIds.push(item);
  });
  addProductsToCart(productIds);
}

function addProductsToCart(productIds) {
  var formData = { items: productIds };
  console.log("formData", formData)
  fetch(`${window.Theme.routes.cart_add_url}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add products to cart');
      }
      return response.json();
    })
    .then(json => {
      console.log("Cart Response", json);
      window.location = window.Theme.routes.cart_url;
    })
    .catch(error => {
      console.error('Error adding products to cart:', error.message);
    });
}

// Register event listeners
document.addEventListener('DOMContentLoaded', function () {
  getSelectedProductIds();

  new DiscreetPackagingUpdater();

  var addToCartButton = document.querySelector('#bundle_add_cart');
  if (addToCartButton) {
    addToCartButton.addEventListener('click', function (event) {
      event.preventDefault();
      updateSelectedProductIds(); // Update selected product IDs
    });
  }
});

// Product page description reviews tabbing
{
  let tabItem = document.querySelectorAll('.js-tab-nav-item');

  if (tabItem.length > 0) {
    tabItem.forEach((item) => {
      item.addEventListener('click', () => {
        tabItem.forEach((item) => {
          item.classList.remove('active');
          let tabFor = item.getAttribute('data-tab-for');
          if (tabFor) document.querySelector(`.js-${tabFor}-tab`).removeAttribute('open');
        });
        item.classList.add('active');
        let tabFor = item.getAttribute('data-tab-for');
        if (tabFor) document.querySelector(`.js-${tabFor}-tab`).setAttribute('open', '');
      });
    });
  }
}

//Remove review tab when no reviews are there
{
  let intervalId = setInterval(() => {
    let reviewsContainer = document.querySelector('.js-reviews-tab');
    if (reviewsContainer) {
      let reviewsList = reviewsContainer.querySelector('#revieList');
      if (reviewsList) {
        document.querySelector('.js-review-tab').classList.remove('hidden');
      }
      if (window.matchMedia("(max-width: 766px)").matches && !reviewsList) {
        document.querySelector('.js-mob-review-tab').classList.add('hidden');
      }
      clearInterval(intervalId);
    }
  }, 500);

  window.addEventListener('load', () => {
    setTimeout(() => {
      clearInterval(intervalId);
    }, 10000);
  })
}


document.addEventListener('DOMContentLoaded', function () {
  var elem = document.querySelector("#announcement-flickity");
  var children = document.querySelectorAll("#announcement-flickity .announcement--item");
  var flkty;
  function initFlickity() {
    if (elem) {
      imagesLoaded(elem, function () {
        flkty = new Flickity(elem, {
          cellSelector: '.announcement--item',
          freeScroll: false,
          autoPlay: false,
          cellAlign: 'center',
          contain: true,
          accessibility: true,
          groupCells: true,
          pageDots: false,
          prevNextButtons: children.length > 1 ? true : false,
          adaptiveHeight: true,
          arrowShape: 'M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z'
        });

        const viewport = elem.querySelector('.flickity-viewport');
        const slider = elem.querySelector('.flickity-slider');
        const sliderWrapper = document.createElement('div');
        sliderWrapper.classList.add('flickity-slider--wrapper');
        viewport.appendChild(sliderWrapper);
        sliderWrapper.appendChild(slider);
      });
    }
  }

  initFlickity();

  window.addEventListener('resize', function () {
    if (flkty) {
      flkty.destroy();
    }
    initFlickity();
  });
});

// document.addEventListener('DOMContentLoaded', function() {
//   var elem = document.querySelector("#cart-flickity");
//   var children = document.querySelectorAll("#cart-flickity .cart-flickity--item");
//   var flkty;
//   function initFlickity() {
//     if (elem) {
//       imagesLoaded(elem, function() {
//         flkty = new Flickity(elem, {
//           cellSelector: '.cart-flickity--item',
//           freeScroll: false,
//           autoPlay: false,
//           cellAlign: 'center',
//           contain: true,
//           accessibility: true,
//           groupCells: true,
//           pageDots: false,
//           prevNextButtons: children.length > 1 ? true : false,
//           adaptiveHeight: true,
//           arrowShape: 'M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z'
//         });

//         const viewport = elem.querySelector('.flickity-viewport');
//         const slider = elem.querySelector('.flickity-slider');
//         const sliderWrapper = document.createElement('div');
//         sliderWrapper.classList.add('flickity-slider--wrapper');
//         viewport.appendChild(sliderWrapper);
//         sliderWrapper.appendChild(slider);
//       });
//     }
//   }

//   initFlickity();

//   window.addEventListener('resize', function() {
//     if (flkty) {
//       flkty.destroy();
//     }
//     initFlickity();
//   });
// });

document.addEventListener('DOMContentLoaded', function () {
  var elem = document.querySelector("#product-bundle-flickity");
  var children = document.querySelectorAll("#product-bundle-flickity .bundle_product_item");
  var flkty;
  function initFlickity() {
    if (elem) {
      imagesLoaded(elem, function () {
        flkty = new Flickity(elem, {
          cellSelector: '.bundle_product_item',
          freeScroll: false,
          autoPlay: false,
          cellAlign: 'left',
          contain: true,
          accessibility: true,
          groupCells: true,
          pageDots: false,
          prevNextButtons: children.length > 1 ? true : false,
          adaptiveHeight: true,
          arrowShape: 'M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z'
        });

        const viewport = elem.querySelector('.flickity-viewport');
        const slider = elem.querySelector('.flickity-slider');
        const sliderWrapper = document.createElement('div');
        sliderWrapper.classList.add('flickity-slider--wrapper');
        viewport.appendChild(sliderWrapper);
        sliderWrapper.appendChild(slider);
      });
    }
  }

  initFlickity();

  window.addEventListener('resize', function () {
    if (flkty) {
      flkty.destroy();
    }
    initFlickity();
  });
});


class QuantityRange extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-quantity-input]');
    this.plus = this.querySelector('[data-quantity-plus]');
    this.minus = this.querySelector('[data-quantity-minus]');
    this.mainWrapper = this.closest('[data-product-details]');
    this.rangeInput = this.querySelector("#rangeInput");
    setTimeout(() => {
      this.rangeInput.value = 1;
      this.input.value = 1;
    }, 1700)

    this.init();
  }

  init() {
    var loadOptionVal;
    var variantSelection = this.mainWrapper.querySelector('.variant-selection');
    var hasOnlyDefaultVariant = variantSelection.querySelector('.variant-selection__variants--default');

    if (hasOnlyDefaultVariant) {
      loadOptionVal = hasOnlyDefaultVariant.getAttribute('data-quantity');
    } else {
      var selectElement = variantSelection.querySelector('.variant-selection__variants');
      var selectedOption = selectElement.options[selectElement.selectedIndex];
      loadOptionVal = selectedOption.getAttribute('data-quantity');
    }

    var optionVal = loadOptionVal;

    let updateRange = () => {
      console.log("updateRange")
      var rangeVal = this.rangeInput.value;
      var mainQuantitySelector = this.input;
      mainQuantitySelector.value = rangeVal;
      mainQuantitySelector.dispatchEvent(new Event('change'));
      this.input.value = rangeVal;
      var maxValue = parseInt(this.rangeInput.max);
      var currentValue = parseInt(this.rangeInput.value);
      var mainValue = (100 / maxValue) * currentValue;
      this.querySelector('.range-background').style.width = mainValue + '%';
      this.querySelector('[data-button-wrapper-plus]').classList.toggle('quantity-selector__button-wrapper--disabled', (mainValue == 100))
      this.updatePrice();

    }
    this.rangeInput.addEventListener('input', updateRange);

    this.plus.addEventListener('click', () => {
      setTimeout(() => {
        this.input.dispatchEvent(new Event('input'));
        updateRange();
      }, 50);
    });

    this.minus.addEventListener('click', () => {
      setTimeout(() => {
        this.input.dispatchEvent(new Event('input'));
        updateRange();
      }, 50);
    });

    this.input.addEventListener('input', () => {
      var rangeEle = this.rangeInput;
      rangeEle.value = this.input.value;
      var maxValue = parseInt(rangeEle.max);
      var currentValue = parseInt(rangeEle.value);
      var mainValue = (100 / maxValue) * currentValue;
      document.querySelector('.range-background').style.width = mainValue + '%';
      this.updatePrice();
    });
  }

  updatePrice() {
    var data_price;
    var variantSelection = document.querySelector('.variant-selection');
    var hasOnlyDefaultVariant = variantSelection.querySelector('.variant-selection__variants--default');
    const inputQuantity = this.rangeInput.value;
    const discountQTY = inputQuantity;

    if (hasOnlyDefaultVariant) {
      data_price = hasOnlyDefaultVariant.getAttribute('data-price');
    } else {
      var selectElement = variantSelection.querySelector('.variant-selection__variants');
      var selectedOption = selectElement.options[selectElement.selectedIndex];
      data_price = selectedOption.getAttribute('data-price');
    }
    const dataPrice = data_price;
    const priceByQuantity = dataPrice * discountQTY;

    if (document.querySelector('.quantity-selector__input')) {
      const quantityNumVal = document.querySelector('.quantity-selector__input').value;
      const quantityNumMax = document.querySelector('.quantity-selector__input').max;
      const mainQuantitySelector = document.querySelector('.quantity-selector .quantity-selector__input');

      if (quantityNumVal > parseInt(quantityNumMax)) {
        event.target.value = quantityNumMax;
        mainQuantitySelector.value = quantityNumMax;
        this.rangeInput.value = quantityNumMax;
      } else if (quantityNumVal == '') {
        // ...
      } else {
        this.rangeInput.value = quantityNumVal;
        mainQuantitySelector.value = quantityNumVal;
      }

      const maxValue = parseInt(document.querySelector('.quantity-selector__input').max);
      const currentValue = parseInt(document.querySelector('.quantity-selector__input').value);
      const mainValue = (100 / maxValue) * currentValue;
      document.querySelector('.range-background').style.width = mainValue + '%';


      const inputQuantity = this.rangeInput.value;
      const discountQTY = inputQuantity;

      let finalDiscountPercent = this.getDiscountPercent(discountQTY, this.getAttribute('data-rule-discount'));

      let messageDiscount = document.getElementById('product-price-discount-label');
      if (finalDiscountPercent != 0) {

        let apppricebyqty = Math.ceil(priceByQuantity - ((priceByQuantity * parseFloat(finalDiscountPercent)) / 100));

        let orgPriceByQuantity = window.Shopify.formatMoney(priceByQuantity, window.Theme.money_format);
        let customappFormatdiscountprice = window.Shopify.formatMoney(apppricebyqty, window.Theme.money_format);


        orgPriceByQuantity = window.Shopify.formatMoney(apppricebyqty, window.Theme.money_format);;
        customappFormatdiscountprice = window.Shopify.formatMoney(priceByQuantity, window.Theme.money_format);;



        document.querySelector('.product-pricing').querySelector('[data-price]').innerHTML = orgPriceByQuantity;

        this.mainWrapper.querySelector('[data-price-compare]').innerHTML = customappFormatdiscountprice;
        this.mainWrapper.querySelector('[data-price-compare-container]').classList.toggle('visible', !(apppricebyqty == 0));
        if (messageDiscount) {
          messageDiscount.style.display = "block";
          let valueDiscountMessage = priceByQuantity - apppricebyqty;
          messageDiscount.innerHTML = window.Theme.text_discount + ' ' + window.Shopify.formatMoney(valueDiscountMessage, window.Theme.money_format);
        }
      } else {
        if (messageDiscount) {
          messageDiscount.style.display = "none";
          messageDiscount.innerHTML = '';
        }
      }
    }
  }
  getDiscountPercent(quantity, ruleString) {
    const rules = ruleString.split(',').map(rule => {
      const [minQty, discount] = rule.trim().split('-').map(Number);
      return { minQty, discount };
    });

    rules.sort((a, b) => b.minQty - a.minQty);

    for (const rule of rules) {
      if (parseInt(quantity) >= rule.minQty) {
        return rule.discount;
      }
    }

    return 0;
  }

  createRenge(optionVal) {
    var optionValString = optionVal.toString();
    if (optionValString.indexOf('-') > -1) {
      document.querySelector('.quantity-selector').style.display = 'block';
      document.querySelector('.range-quantity').style.display = 'none';
      // document.querySelector('.saving-arrow').classList.add('hide');
    }
    else {
      if (optionVal > 5) {
        document.querySelector('.quantity-selector').style.display = 'block';
        document.querySelector('.range-quantity').style.display = 'block';
        document.querySelector('#rangeInput').setAttribute('max', parseInt(optionVal));
        document.querySelector('.quantity-selector__input').setAttribute('max', parseInt(optionVal));
        var oneOfFive = parseInt(optionVal) / 5;
        var roundOneOfFive = Math.round(oneOfFive);
        var starTVal = 0;
        var optionLength = document.querySelectorAll('#tickmarks .tickmarksOpt').length;

        document.querySelectorAll('#tickmarks .tickmarksOpt').forEach(function (element, index) {
          starTVal = starTVal + roundOneOfFive;
          if (index == optionLength - 1) {
            element.textContent = parseInt(optionVal);
          }
          else {
            element.textContent = starTVal;
          }
        });
        // document.querySelector('.saving-arrow').classList.remove('hide');
      }
      else {
        document.querySelector('.quantity-selector').style.display = 'block';
        document.querySelector('.range-quantity').style.display = 'none';
        // document.querySelector('.saving-arrow').classList.add('hide');
      }
    }
  }
}
customElements.define('quantity-range', QuantityRange);

document.addEventListener('DOMContentLoaded', function () {
  let revieBtn = document.querySelectorAll('#leftRevie, #rightRevie');
  const itemsRevie = document.querySelectorAll('#revieListCarousel .itemsC');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const index = Array.from(itemsRevie).indexOf(entry.target);
        revieBtn[0].disabled = index === 0;
        revieBtn[1].disabled = index === itemsRevie.length - 1;
      }
    });
  }, {
    threshold: 0.9
  });

  itemsRevie.forEach((item) => {
    observer.observe(item);
  })
});

class CartRecommendation extends HTMLElement {
  constructor() {
    super();
    this.flkty = null;
    this.slider = this.querySelector("#cart-flickity");
    this.slides = this.querySelectorAll("#cart-flickity .cart-flickity--item");
    this.totalPrice = this.dataset.totalPrice / 100;
    this.priceTier = this.dataset.popupPriceTier.split(',');
    window.addEventListener('resize', this.init.bind(this));
  }

  static get observedAttributes() {
    return ['updating'];
  }
  connectedCallback() {
    this.init();
  }

  init() {
    if (this.flkty) {
      this.flkty.destroy();
      this.flkty = null;
    }
    if (this.slider && this.slides) {
      imagesLoaded(this.slider, () => {
        this.flkty = new Flickity(this.slider, {
          cellSelector: '.cart-flickity--item',
          freeScroll: false,
          autoPlay: false,
          cellAlign: 'center',
          contain: true,
          accessibility: true,
          groupCells: true,
          pageDots: false,
          prevNextButtons: this.slides.length > 1 ? true : false,
          adaptiveHeight: true,
          arrowShape: 'M65.29 11.99L27.28 50L65.3 87.99L70.25 83.06L37.19 50L70.26 16.94L65.29 11.99Z'
        });

        const viewport = this.slider.querySelector('.flickity-viewport');
        const slider = this.slider.querySelector('.flickity-slider');
        const sliderWrapper = document.createElement('div');
        sliderWrapper.classList.add('flickity-slider--wrapper');
        viewport.appendChild(sliderWrapper);
        sliderWrapper.appendChild(slider);
      });
    }
  }

  async update() {
    this.totalPrice = this.dataset.totalPrice / 100;
    const prevTotalPrice = parseFloat(localStorage.getItem('prevTotalPrice')) / 100;
    const tier0 = parseInt(this.priceTier[0]);
    const tier1 = parseInt(this.priceTier[1]);
    const tier2 = parseInt(this.priceTier[2]);

  if (
    (prevTotalPrice > tier0 && prevTotalPrice <= tier1 && this.totalPrice > tier0 && this.totalPrice <= tier1) ||
    (prevTotalPrice > tier1 && prevTotalPrice <= tier2 && this.totalPrice > tier1 && this.totalPrice <= tier2) ||
    (prevTotalPrice > tier2 && this.totalPrice > tier2)
  ) {
    this.removeAttribute('updating');
    return;
  }

    this.flkty.destroy();
    const response = await fetch(window.Shopify.routes.root + "?section_id=cart-drawer");
    const div = document.createElement("div");
    div.innerHTML = await response.clone().text();
    const oldCartRecom = document.querySelector('#cart-flickity');
    const newCartRecom = div.querySelector('#cart-flickity');
    oldCartRecom.innerHTML = newCartRecom.innerHTML;
    this.slider = this.querySelector("#cart-flickity");
    this.slides = this.querySelectorAll("#cart-flickity .cart-flickity--item");
    this.init();
    setTimeout(() => {
      this.removeAttribute('updating');
    }, 1000)
  }

  attributeChangedCallback(name) {
    switch (name) {
      case "updating":
        this.update();
        break;
    }
  }
}
customElements.define('cart-recommendation', CartRecommendation);

class PriceRange extends HTMLElement {
  constructor() {
    super();

    this.rangeMin = this.querySelector('input[type="range"]:first-child');
    this.rangeMax = this.querySelector('input[type="range"]:last-child');
    this.inputMin = this.querySelector('input[name="filter.v.price.gte"]');
    this.inputMax = this.querySelector('input[name="filter.v.price.lte"]');

    this.inputMin.addEventListener('focus', this.inputMin.select);
    this.inputMax.addEventListener('focus', this.inputMax.select);
    this.inputMin.addEventListener('change', this.onInputMinChange.bind(this));
    this.inputMax.addEventListener('change', this.onInputMaxChange.bind(this));

    this.rangeMin.addEventListener('change', this.onRangeMinChange.bind(this));
    this.rangeMax.addEventListener('change', this.onRangeMaxChange.bind(this));
    this.rangeMin.addEventListener('input', this.onRangeMinInput.bind(this));
    this.rangeMax.addEventListener('input', this.onRangeMaxInput.bind(this));
  }

  onInputMinChange(event) {
    event.preventDefault();
    event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(this.inputMax.value || event.target.max) - 1), event.target.min);
    this.rangeMin.value = event.target.value;
    this.rangeMin.parentElement.style.setProperty('--range-min', `${parseInt(this.rangeMin.value) / parseInt(this.rangeMin.max) * 100}%`);
    const priceRangeEvent = new CustomEvent('pricerange:update', {
      detail: this.inputMin
    });
    window.dispatchEvent(priceRangeEvent);
  }

  onInputMaxChange(event) {
    event.preventDefault();
    event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(this.inputMin.value || event.target.min) + 1), event.target.max);
    this.rangeMax.value = event.target.value;
    this.rangeMax.parentElement.style.setProperty('--range-max', `${parseInt(this.rangeMax.value) / parseInt(this.rangeMax.max) * 100}%`);
    const priceRangeEvent = new CustomEvent('pricerange:update', {
      detail: this.inputMax
    });
    window.dispatchEvent(priceRangeEvent);
  }

  onRangeMinChange(event) {
    event.stopPropagation();
    this.inputMin.value = event.target.value;
    this.inputMin.dispatchEvent(new Event('change', { bubbles: true }));
  }

  onRangeMaxChange(event) {
    event.stopPropagation();
    this.inputMax.value = event.target.value;
    this.inputMax.dispatchEvent(new Event('change', { bubbles: true }));
  }

  onRangeMinInput(event) {
    event.target.value = Math.min(parseInt(event.target.value), parseInt(this.inputMax.value || event.target.max) - 1);
    event.target.parentElement.style.setProperty('--range-min', `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
    this.inputMin.value = event.target.value;
  }

  onRangeMaxInput(event) {
    event.target.value = Math.max(parseInt(event.target.value), parseInt(this.inputMin.value || event.target.min) + 1);
    event.target.parentElement.style.setProperty('--range-max', `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
    this.inputMax.value = event.target.value;
  }
}
customElements.define('price-range', PriceRange);

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.site-header');
  const announcement = document.querySelector('.site-announcement');
  let lastScrollTop = 0;
  let announcementHeight = announcement ? announcement.offsetHeight : 0;

  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > announcementHeight) {
      header.classList.add('site-header-sticky');
    } else {
      header.classList.remove('site-header-sticky');
    }

    lastScrollTop = scrollTop;
  }

  window.addEventListener('scroll', handleScroll);

  handleScroll();
});


document.addEventListener('DOMContentLoaded', function () {
  var elem = document.querySelector('.complementary-products__slider');
  var flkty;

  function initFlickity() {
    if (elem) {
      imagesLoaded(elem, function () {
        flkty = new Flickity(elem, {
          cellSelector: '.productgrid--item',
          freeScroll: true,
          autoPlay: false,
          cellAlign: 'left',
          contain: true,
          accessibility: true,
          groupCells: true,
          pageDots: false,
          prevNextButtons: false,
          adaptiveHeight: true,
        });
        const viewport = elem.querySelector('.flickity-viewport');
        const slider = elem.querySelector('.flickity-slider');
        const sliderWrapper = document.createElement('div');
        sliderWrapper.classList.add('flickity-slider--wrapper');
        viewport.appendChild(sliderWrapper);
        sliderWrapper.appendChild(slider);
        document.querySelector('.flickity-prev').addEventListener('click', () => flkty.previous());
        document.querySelector('.flickity-next').addEventListener('click', () => flkty.next());
      });
    }
  }

  initFlickity();

  window.addEventListener('resize', function () {
    if (flkty) {
      flkty.destroy();
    }
    initFlickity();
  });
});

document.addEventListener('DOMContentLoaded', function() {
  let revieBtn = document.querySelectorAll('#leftRevie, #rightRevie');
  const itemsRevie = document.querySelectorAll('#revieListCarousel .itemsC');
  const observerRevie = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
      if (entry.isIntersecting) {
        const index = Array.from(itemsRevie).indexOf(entry.target);
        revieBtn[0].disabled = index === 0;
        revieBtn[1].disabled = index === itemsRevie.length - 1;
      }
    });
  }, {
    threshold: 0.9
  });

  itemsRevie.forEach((item) => {
    observerRevie.observe(item);
  })

    const headingRevie = document.querySelector('.topT').children;
    if(headingRevie.length > 0) {
        const totalRating = headingRevie[0].getAttribute('title');
        const totalReviews = headingRevie[1].textContent;
        localStorage.setItem('totalRating', parseFloat(totalRating));
        localStorage.setItem('totalReviews', totalReviews);
    }


    if (window.location.href.includes('/products')) {
        var carouselRevie = document.querySelector('.sectionRevieWidget3');
        var productReview = document.getElementById('cont-rl-w');
        if(carouselRevie && productReview) {
            carouselRevie.style.display = 'none';
        } else {
            carouselRevie.style.display = 'block';
        }
    }
});